import {
  escapeHtml,
  type PreviewSender,
} from "containers/admin/clients/client/theme-configuration-page/theme-preview/theme-preview.helpers";

export const EMAIL_STYLES = `
  .email-header {
    display: flex;
    gap: 10px;
    padding: 12px 20px;
    background: var(--preview-surface-muted);
    border-bottom: 1px solid var(--preview-border);
    font-size: 14px;
    line-height: 20px;
  }
  .email-avatar {
    display: flex;
    flex-shrink: 0;
    align-items: center;
    justify-content: center;
    width: 40px;
    height: 40px;
    border-radius: 999px;
    background: var(--preview-text-primary);
    color: var(--preview-surface);
    font-weight: 700;
  }
  .email-details { display: flex; flex-direction: column; gap: 4px; }
  .email-sender { display: flex; flex-wrap: wrap; column-gap: 6px; }
  .email-sender-name { font-weight: 600; }
  .email-preheader {
    color: var(--preview-text-secondary);
    font-size: 12px;
    font-weight: 500;
    line-height: 16px;
  }
  .email-body { display: flex; flex-direction: column; gap: 20px; padding: 20px; }
  .email-banner { display: block; width: 100%; height: auto; }
  .button-row { display: flex; }
  .email-headline { display: flex; flex-direction: column; gap: 12px; }
  .email-headline h1 { font-size: 24px; font-weight: 700; line-height: 1.25; }
  .email-headline h2 { font-size: 20px; font-weight: 600; line-height: 1.25; }
  .email-text { font-size: 16px; line-height: 24px; }
  .email-text ul { padding-left: 24px; }
  .email-text .lead { font-weight: 700; }
  .email-signature { display: flex; flex-direction: column; gap: 12px; font-size: 16px; line-height: 24px; }
  .email-footer { color: var(--preview-text-secondary); font-size: 14px; line-height: 20px; }
`;

type EmailBodyArgs = {
  sender: PreviewSender;
  bannerImageUrl?: string;
  clientName?: string;
};

export const buildEmailBody = ({ sender, bannerImageUrl, clientName }: EmailBodyArgs) => `
  <header class="email-header">
    <div class="email-avatar">${escapeHtml(sender.name.charAt(0).toUpperCase())}</div>
    <div class="email-details">
      <div class="email-sender">
        <span class="email-sender-name">${escapeHtml(sender.name)}</span>
        <span>&lt;${escapeHtml(sender.email)}&gt;</span>
      </div>
      <div>Securing Your Teen's Bright Future: College Planning Tips Inside</div>
      <div class="email-preheader">Empower your parenting journey</div>
    </div>
  </header>
  <main class="email-body">
    ${bannerImageUrl ? `<img class="email-banner" src="${escapeHtml(bannerImageUrl)}" alt="" />` : ""}
    <div class="email-headline">
      <h1>Securing Your Teen's Bright Future:<br />College Planning Tips Inside</h1>
      <h2>Strategies and Expert Tips for College Success</h2>
    </div>
    <div class="email-text">
      <p>Dear [Parent's Name],</p>
      <p>
        Navigating the path to college success with your teen just got easier! Explore expert tips and
        essential strategies in our guide,
        <span class="link">"Securing Your Teen's Bright Future: College Planning Tips Inside."</span>
      </p>
      <br />
      <p class="lead">In this comprehensive guide, you'll discover:</p>
      <ul>
        <li>Proven methods for effective college planning.</li>
        <li>Insider tips to streamline the application process.</li>
        <li>Guidance on selecting the right-fit college for your teen.</li>
        <li>Strategies to ensure a successful college transition.</li>
      </ul>
      <br />
      <p>Your teen's bright future starts here. Don't miss out on these valuable insights.</p>
      <p>Empower your parenting journey with actionable advice. Read the guide now!</p>
    </div>
    <div class="button-row"><span class="button">Get the Guide</span></div>
    <div class="email-signature">
      <p>Best regards,<br />${escapeHtml(clientName || "[Your College Name]")}</p>
      <p>P.S. Securing your teen's future is just a click away. Read the guide for a smoother college planning experience.</p>
    </div>
    <p class="email-footer">
      We are contacting you because we received your information from your student or a prior contact with [College Name].
    </p>
  </main>
`;
